module.exports = __webpack_public_path__ + "media/fonts/OFN-v2-4da24923ee2464c6d7e8cf28ac1ef376.svg";